@if (
  {
    row: columnData | async,
  };
  as $
) {
  <p>{{ clientGender[$.row!.clt_gender] }}</p>
}
